import type { SelectProps } from 'antd';
import { DivisionsTypes } from 'shared/enums/substitutions';

export const options: SelectProps['options'] = [
  { value: 'all', label: 'Все подразделения' },
  { value: DivisionsTypes.withoutSupervisors, label: 'Подразделения без руководителей' },
  { value: DivisionsTypes.withActing, label: 'Подразделения с И.О.' },
];
